if (!customElements.get('bs-cabecera')) customElements.define('bs-cabecera', class extends HTMLElement {
  connectedCallback() {
    this.header = this.closest('header-component');
    if (!this.header) return;
    this.ficha = ({ target }) => {
      if (!(target instanceof Element)) return;
      const link = target.closest('.mega-menu__link');
      const rutaMenu = link?.closest('.menu-list__list-item')?.querySelector('[ref="menuitem"]')?.getAttribute('href');
      if (!rutaMenu?.endsWith('#servicios')) return;
      this.header.querySelectorAll('.bs-ficha').forEach(card =>
        card.toggleAttribute('data-bs-activa', card.dataset.ruta === link.getAttribute('href')));
    };
    ['pointerover', 'focusin'].forEach(type => this.header.addEventListener(type, this.ficha));
    this.retenerFoco = event => {
      const item = event.target;
      if (this.header.dataset.menuStyle !== 'menu' || !(item instanceof Element)) return;
      if (!item.matches('.menu-list__list-item') || !this.header.contains(item)) return;
      if (!item.contains(document.activeElement)) return;
      if (!item.querySelector('[aria-expanded="true"]')) return;
      event.stopPropagation();
    };
    window.addEventListener('pointerleave', this.retenerFoco, true);
    if (!('IntersectionObserver' in window)) return;
    this.observer = new IntersectionObserver(entries => entries.forEach(({ target, isIntersecting }) => {
      const hero = target.hasAttribute('data-bs-cta-hero');
      document.documentElement.toggleAttribute(hero ? 'data-bs-cta-fuera' : 'data-bs-cierre-dentro', hero ? !isIntersecting : isIntersecting);
    }), { root: null });
    document.querySelectorAll('[data-bs-cta-hero], [data-bs-section="bs-cierre"]').forEach(node => this.observer.observe(node));
  }
  disconnectedCallback() {
    this.observer?.disconnect();
    window.removeEventListener('pointerleave', this.retenerFoco, true);
    ['pointerover', 'focusin'].forEach(type => this.header?.removeEventListener(type, this.ficha));
  }
});
